import { createFileRoute } from "@tanstack/react-router";
import AdvisorToolPage from "@/features/public/pages/tools/advisor";

export const Route = createFileRoute("/(public)/_public/tools/advisor")({
  component: AdvisorToolPage,
});
